<div class="bottom-navigation-container">
    <ul class="bottom-navigation">
        <li>
            <a (click)="navigateTo('/')">
                <div
                    class="bottom-navigation-item"
                    [class.active]="!['/membership', '/offers', '/refer', '/account'].includes(step)">
                    <div class="nav-icon nav-icon--home"></div>
                    <div class="clearfix"></div>
                    <span class="nav-text">Home </span>
                </div>
            </a>
        </li>
        <li>
            <a (click)="navigateTo('/offers')">
                <div class="bottom-navigation-item" [class.active]="step == '/offers'">
                    <div class="nav-icon nav-icon--offers"></div>
                    <div class="clearfix"></div>
                    <span class="nav-text">offers </span>
                </div>
            </a>
        </li>
        <li>
            <a (click)="navigateTo('/membership')">
                <div class="bottom-navigation-item" [class.active]="step == '/membership'">
                    <div class="nav-icon nav-icon--eatclub"></div>
                    <div class="clearfix"></div>
                    <span class="nav-text">{{ staticText.pass_name }} </span>
                </div>
            </a>
        </li>
        <li>
            <a data-test="offer-page" (click)="navigateTo('/refer')">
                <div class="bottom-navigation-item" [class.active]="step.includes('/refer')">
                    <div class="nav-icon nav-icon--refer"></div>
                    <div class="clearfix"></div>
                    <span class="nav-text">{{ staticText.share.offer }} </span>
                </div>
            </a>
        </li>
        <li>
            <a data-test="account-page" (click)="navigateTo('/account')">
                <div class="bottom-navigation-item" [class.active]="step == '/account'">
                    <div class="nav-icon nav-icon--account"></div>
                    <div class="clearfix"></div>
                    <span class="nav-text">Account </span>
                </div>
            </a>
        </li>
    </ul>
</div>
